import styled from 'styled-components';

export const LocationInputWrapper = styled.div`
  display: inline-flex;
  position: relative;
  align-items: center;
  width: 100%;
`;
